// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4e642f82","977":"988e79fa"}[chunkId] + ".chunk.js";
};